import { apiFetcher } from '@/config/api-fetcher.config';
import type { TranslationsGetRequestBody } from '@/server/api/rest/translations';
import type { GetContentTranslations } from '@embira/translations';
import {
  isJsonApiSuccessResponse,
  type JsonApiResponse,
} from '@httpx/json-api';

export const fetchTranslations = async ({
  model,
  foreignKeys,
  locale,
  fields,
}: TranslationsGetRequestBody) => {
  return apiFetcher<JsonApiResponse<GetContentTranslations>>(
    `/api/rest/translations?${new URLSearchParams({
      model,
      foreignKeys,
      locale,
      fields,
    })}`
  ).then((resp) => {
    if (!isJsonApiSuccessResponse(resp)) {
      throw new Error(
        // @todo improve error reporting
        `Failed to update sidebar state: ${JSON.stringify('errors' in resp ? resp.errors : '')}`
      );
    }
    return resp.data;
  });
};
